import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppRouterService {

  constructor(
      private router: Router,
      
  ) { }

  async  rutas_app(xvalor:any){
    try {
      this.router.navigate([xvalor]);
    } catch (error) {
      console.log(error);
    }
  }
async  rutas_app_param(xvalor:any, param:any){
    try {
      await this.router.navigate([xvalor,param]);
    } catch (error) {
      console.log(error);
    }
  }
}
